// extracted by mini-css-extract-plugin
module.exports = {"container":"language-selector-overlay_container__S_A4h","fade-in":"language-selector-overlay_fade-in__3HBMu"};